module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QIUCQgEdBKEsQAAAHBJREFUSMdjYBgFo2AUoAFGUjXccrE4xcjw35SBgeGk6p6TFqTqZyLdhf9NoUxzcnzIRO8gHf4WMhKZQIgFBBMSE5EJhFhgTlmQMjKcItHCE1TPh7ddzP/D2Kp7TjKOptIhaCEiIZ1gGAWjYBQMSQAA6M8WFunY+d8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/5.png
// module id = W4Ck
// module chunks = 0